export const UpdateSystem = {
  data() {
    return {
      refreshing: false,
      registration: null,
      updateExists: false,
    }
  },
  
  created() {
    document.addEventListener('swUpdated', this.updateAvailable)
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.refreshing) return
      this.refreshing = true;
      this.$global.TriggerReload();
    })
  },

  updated(registration) {
    if (registration && registration?.waiting) {
      document.dispatchEvent(new CustomEvent('swUpdated', { detail: registration }));
    }
  },
  
  methods: {
    updateAvailable(event) {
      this.registration = event.detail;
      this.updateExists = true;
    
      // if the user is on the login page, update the app
      if (this.$route.path === '/login') {
        this.updateNow();
      }
    },

    async updateNow() {
      const forceReload = () => {
        if ('caches' in window) {
          caches.keys().then(names => Promise.all(names.map(n => caches.delete(n))))
            .then(() => this.$nextTick(() => {
              this.$global.TriggerReload();
            }));
        } else {
          this.$nextTick(() => {
            this.$global.TriggerReload();
          });
        }
      };
    
      try {
        const reg = this.registration || await navigator.serviceWorker.getRegistration();
        if (!reg || !reg.waiting) return forceReload();
    
        // listen for the controllerchange event before sending the message
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          this.$nextTick(() => {
            this.$global.TriggerReload();
          });
        }, { once: true });
    
        // send the update command
        reg.waiting.postMessage({ type: 'SKIP_WAITING' });
        
        // additional security in case the event is not triggered in a second
        setTimeout(forceReload, 3000); 
    
      } catch (e) {
        // if there is an error, force reload
        forceReload();
      }
    },
    
    refreshApp() {
      this.updateExists = false;
      if (!this.registration || !this.registration.waiting) return
      this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    },
  
  },
};
